// frontend/src/utils/csvExport.ts

export interface CSVExportData {
  headers: string[];
  rows: (string | number)[][];
  filename: string;
}

/**
 * Converts data to CSV format and triggers download
 */
export const downloadCSV = (data: CSVExportData): void => {
  const { headers, rows, filename } = data;

  // Create CSV content
  const csvContent = [
    // Add headers
    headers.join(','),
    // Add data rows
    ...rows.map(row =>
      row.map(cell => {
        // Handle cells that contain commas, quotes, or newlines
        const cellStr = String(cell);
        if (cellStr.includes(',') || cellStr.includes('"') || cellStr.includes('\n')) {
          return `"${cellStr.replace(/"/g, '""')}"`;
        }
        return cellStr;
      }).join(',')
    )
  ].join('\n');

  // Create blob and download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');

  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
};

/**
 * Formats time in minutes to HH:MM format for CSV
 */
export const formatTimeForCSV = (minutes: number): string => {
  const hours = Math.floor(Math.abs(minutes) / 60);
  const mins = Math.abs(minutes) % 60;
  const sign = minutes < 0 ? '-' : '';
  return `${sign}${hours}:${mins.toString().padStart(2, '0')}`;
};

/**
 * Formats date for CSV export in ISO format (YYYY-MM-DD) for Excel compatibility
 */
export const formatDateForCSV = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};